import React from 'react';
import { FormattedMessage } from 'react-intl';
import {
	VehicleType,
	CaseGetControlQueryResultValidationResult,
	EasyClaimDocumentType,
} from 'src/easyclaim.api.client.typescript/src';
import { SolvdCamera } from 'src/easyclaim.app.assets/icons/SolvdCamera';
import { ImageFileInputType, SelectImage, SelectImageBase } from 'src/easyclaim.app.components';
import {
	FeedbackMode,
	ImageRecognitionFeedback2,
} from 'src/easyclaim.app.components/common/ImageRecognitionFeedback2';
import { OdometerPlaceholder } from 'src/easyclaim.app.components/common/ImageRepository';
import { CustomerConfiguration } from 'src/easyclaim.app.contexts/CustomerConfigurationContextCore';
import { EasyClaimService, Image } from 'src/easyclaim.app.services';

interface OdometerImageV2Props {
	caseId?: string;
	selectImageRef: React.RefObject<SelectImageBase>;
	easyClaimService?: EasyClaimService;
	currentImage?: Image;
	inputError?: boolean;
	vehicleType?: VehicleType;
	isDashboardMileageTextInputVisible?: boolean;
	isDashboardMileageTextInputValidationVisible?: boolean;
	componentId?: string;
	dashboardMileageTextValidationResults?: CaseGetControlQueryResultValidationResult[] | null;
	groupFeedback?: boolean;
	odometerInput?: React.ReactNode;
	onChange?: (image: Image | undefined) => void;
}

export const OdometerImageV2 = ({
	caseId,
	selectImageRef,
	easyClaimService,
	currentImage,
	inputError,
	vehicleType,
	isDashboardMileageTextInputVisible,
	isDashboardMileageTextInputValidationVisible,
	componentId,
	dashboardMileageTextValidationResults,
	groupFeedback,
	odometerInput,
	onChange,
}: OdometerImageV2Props) => {
	const config = CustomerConfiguration();

	return (
		<>
			<div className="main-container photo-main-container">
				<FormattedMessage id="vehicleMileage.description" />
				<SelectImage
					ref={selectImageRef}
					componentId="vehicleMileage"
					imageFileInputType={ImageFileInputType.CapturePicture}
					fileType={EasyClaimDocumentType.DashboardPicture}
					caseId={caseId}
					easyClaimService={easyClaimService}
					currentImage={currentImage}
					title="vehicleMileage.title"
					placeholder={<OdometerPlaceholder />}
					marginBottom="1rem"
					onChange={(image) => {
						onChange?.(image);
					}}
					showUserFeedbackInfo={true}
					configuration={config!}
					inputError={inputError}
					vehicleType={vehicleType}
					disableContainerClick={currentImage ? true : false}
				/>
				<button
					className={`button-take-photo ${currentImage ? 'hidden' : ''}`}
					onClick={() => selectImageRef.current?.onContainerClick(false)}
				>
					<SolvdCamera />
					<FormattedMessage id="button.photo.take" />
				</button>

				{isDashboardMileageTextInputVisible && currentImage && (
					<div className="odometer-and-mileage-detail-container">
						{odometerInput}
						{isDashboardMileageTextInputValidationVisible && (
							<div className="mileage-text-input-result">
								<ImageRecognitionFeedback2
									validationId={`${componentId}_mileage`}
									uploadResult={{ validationResults: dashboardMileageTextValidationResults }}
									feedbackMode={FeedbackMode.Main}
									groupFeedback={groupFeedback}
								/>
							</div>
						)}
					</div>
				)}
			</div>
		</>
	);
};
